import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-licenciamentos',
  template: require('./licenciamentos.component.html')
})
export class LicenciamentosComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}



/** WEBPACK FOOTER **
 ** ./~/angular2-template-loader!./src/app/despachos/licenciamentos/licenciamentos.component.ts
 **/